import Icon from '../../../components/AppIcon';

const QRInstructions = ({ discountPercentage, terms }) => {
  return (
    <div className="bg-card rounded-lg shadow-card p-6 mb-6">
      <h2 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="QrCode" size={24} color="var(--color-primary)" />
        Cómo Usar tu Descuento
      </h2>
      <div className="bg-accent/10 border border-accent rounded-lg p-6 mb-6">
        <div className="flex items-start gap-4 mb-4">
          <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center flex-shrink-0">
            <Icon name="Percent" size={24} color="var(--color-accent-foreground)" />
          </div>
          <div>
            <h3 className="text-xl font-bold text-foreground mb-2">
              {discountPercentage}% de Descuento
            </h3>
            <p className="text-muted-foreground">
              Obtén este descuento exclusivo en tu próxima compra
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-4 mb-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <span className="text-lg font-bold text-primary">1</span>
          </div>
          <div>
            <h4 className="font-semibold text-foreground mb-1">Haz clic en "Escanear QR"</h4>
            <p className="text-sm text-muted-foreground">
              Presiona el botón azul en la parte superior para ver tu código QR personal
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <span className="text-lg font-bold text-primary">2</span>
          </div>
          <div>
            <h4 className="font-semibold text-foreground mb-1">Muestra el código al negocio</h4>
            <p className="text-sm text-muted-foreground">
              El personal del negocio escaneará tu código QR para registrar tu visita
            </p>
          </div>
        </div>

        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <span className="text-lg font-bold text-primary">3</span>
          </div>
          <div>
            <h4 className="font-semibold text-foreground mb-1">Recibe tu descuento</h4>
            <p className="text-sm text-muted-foreground">
              Tu descuento de {discountPercentage}% se aplicará automáticamente a tu compra
            </p>
          </div>
        </div>
      </div>
      <div className="bg-muted rounded-lg p-4">
        <h4 className="font-semibold text-foreground mb-3 flex items-center gap-2">
          <Icon name="FileText" size={18} color="var(--color-primary)" />
          Términos y Condiciones
        </h4>
        <ul className="space-y-2 text-sm text-muted-foreground">
          {terms?.map((term, index) => (
            <li key={index} className="flex items-start gap-2">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
              <span>{term}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default QRInstructions;